import React from "react";
import { styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from "@mui/material";
import { usePhoneMode } from "../../hooks";

export default function EngineInfoMaintenanceTab({ maintenanceInfo }) {
    const { isMobile } = usePhoneMode();
    const theme = useTheme();
    const scrollViewerTop = theme.appBar.height;
    const { engineMaintenanceGroups } = maintenanceInfo;

    let heightOffset = '9.0em';
    if(isMobile) {
        heightOffset = '7.0em';
    }

    return (
        <div>
            <TableContainer style={{ maxHeight: `calc(100vh - ${scrollViewerTop}px - ${heightOffset})` }}>
                <Table size={isMobile ? "small" : "medium"}>
                    {engineMaintenanceGroups.map((group, index) => {
                        return (
                            <React.Fragment key={index}>
                                <TableHead>
                                    <HeaderTableRow>
                                        <HeaderTableCell colSpan={2}>{group.groupName}</HeaderTableCell>
                                    </HeaderTableRow>
                                </TableHead>
                                <TableBody>
                                    {group.engineMaintenanceItems.map((item, itemIndex) => (
                                        <StyledTableRow key={itemIndex}>
                                            <TableCell>{item.name}</TableCell>
                                            <TableCell>{item.value}</TableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </React.Fragment>
                        );
                    })}
                </Table>
            </TableContainer>
        </div>
    )
}

const HeaderTableRow = styled(TableRow)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main
}));

const HeaderTableCell = styled(TableCell)(({ theme }) => ({
    color: theme.palette.common.white
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));